import "@ezuikit/player-hls/dist/style/css.js";
import HlsPlayer from "@ezuikit/player-hls";
export default {
  data: function data() {
    return {
      pageConfig: {
        editPageName: '摄像头播放',
        detailFunName: 'videoDetail'
      },
      url: ''
    };
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    idName: {
      type: String,
      default: ''
    },
    playUrl: {
      type: String,
      default: ''
    }
  },
  mounted: function mounted() {
    this.url = this.playUrl;
    if (this.playUrl) {
      this.initPlayer();
    } else {
      this.query();
    }
  },
  onUnmounted: function onUnmounted() {
    this.destroy();
  },
  destroyed: function destroyed() {
    this.destroy();
  },
  methods: {
    query: function query() {
      var _this = this;
      this.$api['videoPlayUrl'](this.id).then(function (res) {
        if (res.data) {
          _this.url = res.data;
          _this.initPlayer();
        }
      });
    },
    initPlayer: function initPlayer() {
      var _this2 = this;
      this.destroy();
      this.player = new HlsPlayer({
        id: "valveVideogj".concat(this.idName || this.id),
        url: this.url,
        staticPath: '/',
        decoderType: 'soft',
        hasAudio: false,
        autoPlay: true,
        muted: true,
        scaleMode: 1
      });
      this.player.on("initSuccess", function (info) {
        return console.log('initSuccess!!!!!!!', info);
      });
      this.$nextTick(function () {
        var _this2$player;
        (_this2$player = _this2.player) === null || _this2$player === void 0 || _this2$player.play();
      });
    },
    destroy: function destroy() {
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }
    }
  }
};